import { useEffect } from 'react'
import ClientListReport from '../layout/Admin/reports/ClientListReport'
import { formatCurrency } from '../../utils/formatAmount'
import ErrorMessage from '../ui/ErrorMessage'
import Loading from '../ui/Loading'
import LoadingModal from '../modals/LoadingModal'
import HeadBoxReport from '../layout/Admin/reports/HeadBoxReport'
import ChapelsCheckbox from '../layout/Admin/reports/ChapelsCheckbox'
import DateRangeExportBtn from '../layout/Admin/reports/DateRangeExportBtn'
import { useDispatch, useSelector } from 'react-redux'
import { selectCurrentModalType } from '../../features/modal/modalSlice'
import ClientReport from '../modals/Admin/ClientReport'
import { ClientData } from '../../types/reports'
import { useMutationData } from '../../hooks/api/useMutationData'
import { selectDateRangeReport, selectSelectedChapelReport, selectSelectedClientReport, setSelectedChapelReport, setSelectedClientReport } from '../../features/reports/reportsSlice'
import useReport from '../../hooks/actions/useReport'
import ChapelReportList from '../common/ChapelReportList'

export default function Reports() {

    const dispatch = useDispatch()
    const selectCurrentModal = useSelector(selectCurrentModalType)
    const { isLoadingExportSalesExcel } = useMutationData()
    const selectedChapel = useSelector(selectSelectedChapelReport)
    const selectedClient = useSelector(selectSelectedClientReport)
    const { 
        simplifiedChapels,
        dataReportByDateRangeAndChapelIds,
        isLoadingReportByDateRangeAndChapelIds,
        isErrorReportByDateRangeAndChapelIds,
        errorMessageReportReportByDateRangeAndChapelIds,
        reportStats,
        hasNoData,
        sortedClients
    } = useReport()

    useEffect(() => {
        if (simplifiedChapels.length > 0 && selectedChapel.length === 0) {
            dispatch(setSelectedChapelReport(simplifiedChapels))
        }
    }, [simplifiedChapels, dispatch, selectedChapel]);


    const actualSalesFormat = `₱${formatCurrency(reportStats.actualSales)}`;
    const amountToBeBilledFormat = `₱${formatCurrency(reportStats.amountToBeBilled)}`;

    const handleOpenClientReport = (client: ClientData) => {
        dispatch(setSelectedClientReport(client))
    };
    
    const isShowClientModalReport = selectCurrentModal === 'clientReport' && selectedClient

    return (
        <div className='bg-white rounded-md w-full h-full p-4 flex-1 flex flex-col space-y-2 overflow-hidden'>
            <div className={`flex justify-between`}>
                <p className='text-sm font-medium flex items-center justify-center'>
                    Reports Management
                </p>    
            </div>
            <div className='flex flex-col space-y-1'>
                <DateRangeExportBtn />
                <ChapelReportList/>
            </div>
            <hr className="h-[5px] bg-gray-300 border-0 " />
            <div className="overflow-hidden h-full rounded">
                <div className="pr-2 h-full rounded overflow-y-auto space-y-2">
                    {isLoadingReportByDateRangeAndChapelIds ? (
                        <Loading message="Loading..." />
                    ) : isErrorReportByDateRangeAndChapelIds ? (
                        <div className="h-full flex justify-center items-center">
                            <ErrorMessage message={errorMessageReportReportByDateRangeAndChapelIds} />
                        </div>
                    ) : dataReportByDateRangeAndChapelIds === undefined || hasNoData ? (
                        <div className="h-full flex justify-center items-center">
                            <p className='text-center text-sm text-gray-500 py-6'>Select a date range and at least one chapel to view the report.</p>
                        </div>
                    ) : (
                        <>
                            <div className="grid grid-cols-3 sm:grid-cols-2 md:grid-cols-5 gap-3">
                                <HeadBoxReport headBoxTitle={`Actual Sales`} headBoxValue={actualSalesFormat} />
                                <HeadBoxReport headBoxTitle={`Actual Billed`} headBoxValue={amountToBeBilledFormat} />
                                <HeadBoxReport headBoxTitle={`No. of Clients`} headBoxValue={reportStats.numberOfClients ?? ''} />
                                <HeadBoxReport headBoxTitle={`No. of Guest`} headBoxValue={reportStats.numberOfGuest ?? ''} />
                                <HeadBoxReport headBoxTitle={`No. of Cups Serve`} headBoxValue={reportStats.totalCupsConsumed} />
                            </div>
                            <div className='h-full rounded'>
                                <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                                    {sortedClients.map((client) => (
                                        <ClientListReport
                                            key={client.clientID}
                                            client={client}
                                            onOpenModal={() => handleOpenClientReport(client)}
                                        />
                                    ))}
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
            
            {isShowClientModalReport &&  <ClientReport />}
            {isLoadingExportSalesExcel && <LoadingModal/>}
        </div>
    )
}
